import React, { useEffect, useRef } from 'react';
import { FiPackage } from 'react-icons/fi';
import Fade from 'react-reveal/Fade';
import { useLocation } from 'react-router-dom';
import LoaderPrimary from '../../components/LoaderPrimary/LoaderPrimary';
import { useQuery } from '@tanstack/react-query';
import { Image } from 'primereact/image';
import { MdDonutLarge } from 'react-icons/md';
import { HiCode } from 'react-icons/hi';
import { FaGithubAlt, FaTelegramPlane } from 'react-icons/fa';
import Zoom from 'react-reveal/Zoom';
import useTitle from '../../hook/useTitle';

const ProjectDetails = () => {
  const ref = useRef();
  useTitle('Portfolio || Project Details');
  const { pathname } = useLocation();
  const projectId = pathname?.split('/')[2];

  const { data: projectDetails = [], isLoading } = useQuery({
    queryKey: ['projectDetails', projectId],
    queryFn: async () => {
      const res = await fetch(
        `https://my-portfolio-back-end.vercel.app/projectDetails/${projectId}`
      );
      const data = await res.json();
      return data;
    },
  });

  if (isLoading) {
    return (
      <div className="mt-20">
        <LoaderPrimary></LoaderPrimary>
      </div>
    );
  }
  const {
    projectImg01,
    projectImg02,
    projectImg03,
    projectImg04,
    projectImg05,
    projectImg06,
    features,
    projectTitle,
    technologies,
    projectDescription,
    liveLink,
    githubClientRepo,
    githubServerRepo,
  } = projectDetails;

  return (
    <section className="w-10/12 md:w-8/12 lg:w-10/12 mx-auto my-12 lg:my-24 ">
      {projectDetails?._id ? (
        <div>
          <Fade top>
            <div className="flex flex-col lg:flex-row items-center justify-center mb-6">
              <h2 className=" w-full  text-2xl lg:text-5xl text-[#ccd7f7] font-bold tracking-tight inline-flex justify-start  items-center">
                <HiCode className="text-[#64feda] mr-1" /> Project Description
              </h2>
              <span className="w-full inline-block h-[2px] lg:h-[3px] bg-[#8891b0] bg-opacity-40 mt-1 lg:mt-3"></span>
            </div>
          </Fade>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 card">
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg01 ? projectImg01 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg02 ? projectImg02 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg03 ? projectImg03 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg04 ? projectImg04 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg05 ? projectImg06 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
            <Zoom bottom>
              <Image
                style={{
                  height: '150px',
                  overflowY: 'hidden',
                  border: '2px solid #8891b0',
                  borderRadius: '8px',
                }}
                src={projectImg06 ? projectImg06 : 'Image not found'}
                alt="Image"
                preview
              />
            </Zoom>
          </div>
          <div>
            <Fade bottom>
              <h2 className="text-md lg:text-2xl my-2 font-bold text-[#ccd7f7]">
                Project title:{' '}
                <span className="text-sm lg:text-2xl font-mono bg-[#64feda]  text-[#0a1930] px-3 rounded-md">
                  {projectTitle ? projectTitle : 'Title not found'}
                </span>
              </h2>
            </Fade>
            <Fade bottom>
              <h5 className="text-md lg:text-2xl my-2 font-bold text-[#ccd7f7]">
                Project Description:{' '}
                <span className="font-mono bg-[#64feda] text-[#0a1930] px-3 rounded-md text-sm lg:text-2xl">
                  {projectDescription
                    ? projectDescription
                    : 'Description not found'}
                </span>
              </h5>
            </Fade>
            <Fade bottom>
              <ul className="font-semibold">
                <li className="font-bold text-md lg:text-2xl mt-3 mb-1 text-[#ccd7f7]">
                  Project Features
                </li>
                {features ? (
                  features.split('*').map((feature, index) => (
                    <Zoom key={index}>
                      <li className="text-sm lg:text-2xl">
                        <MdDonutLarge className="mr-1 inline-block text-[#64feda]" />
                        {feature}
                      </li>
                    </Zoom>
                  ))
                ) : (
                  <Fade bottom>
                    <li>Features data not found</li>
                  </Fade>
                )}
              </ul>
            </Fade>
            <Fade bottom>
              <ul className="font-mono font-semibold ">
                <li className="font-bold text-md lg:text-2xl mt-3 mb-1 text-[#ccd7f7]">
                  Technologies
                </li>
                {technologies ? (
                  technologies.split('*').map((tech, index) => (
                    <Zoom key={index}>
                      <li className=" text-sm lg:text-2xl inline-flex items-center mr-4">
                        <FiPackage className="mr-1 text-[#64feda]" /> {tech}
                      </li>
                    </Zoom>
                  ))
                ) : (
                  <Fade bottom>
                    <li>Technologies not found</li>
                  </Fade>
                )}
              </ul>
            </Fade>
            <div className=" mt-4 flex flex-col lg:flex-row space-x-0 lg:space-x-8">
              <Zoom>
                <a
                  rel="noreferrer"
                  href={githubClientRepo}
                  target="_blank"
                  title="github client"
                >
                  <span className="bg-[#ccd7f7] text-sm font-semibold font-mono tracking-tight inline-flex px-2 items-center text-[#0a1930] rounded-full leading-6">
                    <FaGithubAlt className="text-lg  lg:text-3xl mr-1" /> Github
                    client
                  </span>
                </a>
              </Zoom>
              <Zoom>
                <a rel="noreferrer" href={githubServerRepo} target="_blank">
                  <span className="bg-[#ccd7f7] text-sm font-semibold font-mono tracking-tight inline-flex px-2 items-center text-[#0a1930] rounded-full leading-6">
                    <FaGithubAlt className="text-lg  lg:text-3xl mr-1" /> Github
                    server
                  </span>
                </a>
              </Zoom>
              <Zoom>
                <a
                  rel="noreferrer"
                  href={liveLink}
                  target="_blank"
                  title="live"
                  className=""
                >
                  <span className="bg-[#ccd7f7] text-sm font-semibold font-mono tracking-tight inline-flex px-2 items-center text-[#0a1930] rounded-full leading-6">
                    <FaTelegramPlane className="text-lg  lg:text-3xl mr-1" />{' '}
                    Live link
                  </span>
                </a>
              </Zoom>
            </div>
          </div>
        </div>
      ) : (
        <section className="w-full flex -mt-24 items-center justify-center">
          <Fade bottom>
            <h3 className="text-[#64feda] text-2xl my-24">Data not found</h3>
          </Fade>
        </section>
      )}
    </section>
  );
};

export default ProjectDetails;
